import {BaseViewModel} from "../base-view-model";
import {BaseLinkModel} from "../link/base-link-model";
import {EntityLogoRequestParams} from "../params/entity-logo-request-params";
import {BaseMetadataModel} from "../base-metadata-model";
import {Type} from "../../type";

export class EntityViewModel extends BaseViewModel {
  get imageVersion(): Number {
    return this.domainModel.imageVersion;
  }

  get shortName(): Number {
    return this.domainModel.shortName;
  }

  get longName(): Number {
    return this.domainModel.longName;
  }

  get nameForURL(): Number {
    return this.domainModel.nameForURL;
  }

  get logoParams(): EntityLogoRequestParams {
    // throw new Error('logoParams computed are not implemented');
    return '';
  }

  get logoType(): Type {
    return EntityLogoRequestParams;
  }

  get linkModel(): BaseLinkModel {
    // throw new Error('linkModel computed are not implemented');
    return null;
  }

  get createdAt(): Number {
    return this.domainModel ? this.domainModel?.createdAt : null;
  }

  get isFollow(): Boolean {
    return this.domainModel ? this.domainModel?.isFollow : null;
  }

  toString(): * {
    return this.name;
  }

  get metadataType(): BaseMetadataModel {
    return BaseMetadataModel;
  }

  get expiredTimeStampMS(): Number{
    return null;
  }

  get logoEntity(): BaseViewModel {
    return null;
  }

  get objectType() {
    return this.constructor.name;
  }
}
